export default __webpack_public_path__ + "static/media/icon-app-white.b16b8836.svg";